import React from "react";
import SearchableCombobox from "@/components/SearchableCombobox";

/**
 * Searchable picker for vendors — e.g. Stock In (GRN) vendor selection.
 *
 * Secondary line shows purpose/status when available. Search covers name
 * and purpose.
 */
export default function VendorCombobox({
  vendors = [],
  value = "",
  onPick,
  testId = "vendor-combobox",
  placeholder = "Search vendor…",
  className = "",
  disabled = false,
}) {
  return (
    <SearchableCombobox
      options={vendors}
      value={value}
      onPick={onPick}
      testId={testId}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      emptyLabel="No matching vendors."
      getId={(v) => v.id}
      getKey={(v) => v.id}
      getLabel={(v) => v.name || ""}
      getSecondary={(v) => [v.purpose, v.status].filter(Boolean).join(" · ")}
      getSearchFields={(v) => [v.name, v.purpose]}
    />
  );
}
